import { FC } from 'react'
import Style from './Spinner.module.scss'

import { BeatLoader } from 'react-spinners'

export const Spinner: FC<unknown> = () => {
    return (
        <div className={Style.wrapper}>
            <BeatLoader color="#10F48B" size={10} speedMultiplier={0.6} />
        </div>
    )
}
